import React from 'react';
import './Research.css';

const Research = () => {
  return (
    <section id="research" className="research-section">
      <div className="container">
        <h2>研究・プロジェクト活動</h2>
        
        <div className="research-block">
          <h3>主な研究トピックと興味領域</h3>
          <ul>
            <li>外国語教育学・第二言語習得論・応用言語学</li>
            <li>大規模言語モデル（LLM）のファインチューニング・構築</li>
            <li>機械学習を用いた語彙難易度予測・言語評価</li>
            <li>教育文法および学術目的の英語教育</li>
          </ul>
        </div>
        
        <div className="research-block">
          <h3>研究における苦労や失敗の克服エピソード</h3>
          <h4>大規模言語モデルを使った語彙難易度推定</h4>
          <p>
            LLM（大規模言語モデル）に直接「この単語はどれくらい難しいか？」と尋ねても、正確な難易度が得られないという課題に直面。
            そこで、既に難易度がわかっている数千～数万単語のデータを比較・分析し、新たに未知の語彙データも既存データと照合してモデルに学習させるアプローチを採用。
            しかし、R²（決定係数）が思うように高まらず、予測精度が低迷。国立国語研究所の先生方をはじめとする機械学習の専門家に助言を仰ぎ、特徴量の選定やアルゴリズムの調整を行うことで精度を改善。
            「自分より優れた専門家に積極的に相談し、柔軟に取り入れる姿勢」の重要性を再認識するきっかけとなった。
          </p>
        </div>
        
        <div className="research-block">
          <h3>興味のある今後の研究分野</h3>
          <h4>オリジナルのLLM構築</h4>
          <p>
            既存モデル（LLaMAなど）をベースにファインチューニングするアプローチだけでなく、独自のコーパス・アーキテクチャを組み合わせた新しい大規模言語モデルを作りたいと考えている。
            既存LLMの制約や安全上の制限を回避し、自身のスキルや専門性をさらに深めるためにも、独自開発に強い関心を持っている。
          </p>
        </div>

        <div className="research-block">
          <h3>チームでの研究・開発経験</h3>
          <p>
            学部時代から修士・博士課程にかけて、アプリ開発や教育用ウェブサービスのプロジェクトに参加。
            Swiftを使った英語学習用アプリ（「LANDS」）の開発ではチームリーダーを担当。GitやDockerなどのツールを初めて導入し、チーム内の開発環境を統一した。
            修士・博士段階では、国立国語研究所の語彙分析プロファイラー開発や日本語教育アプリの開発など、複数の大型プロジェクトに参画し、要件定義から設計・実装・デプロイまで一貫して関わる。
          </p>
        </div>

        <div className="research-block">
          <h3>就職活動でアピールしたい点・今後のキャリア志向</h3>
          <p>
            IT業界への就職を希望し、大規模言語モデル（LLM）開発や運用、応用研究に携わりたい。
            機械学習と外国語教育の知見を合わせ、教育系サービスや学習支援ツールなどに革新的なソリューションを提供できると考えている。
            リーダーシップや開発プロセス全体への理解、国際的な視点（日中バイリンガル、留学・研究経験）を強みとして活かしたい。
          </p>
        </div>
      </div>
    </section>
  );
};

export default Research;